import CircularProgress from '@mui/material/CircularProgress';
import { createTheme, ThemeProvider, StyledEngineProvider, adaptV4Theme } from '@mui/material/styles';
import {
  BLUE_PLOOT,
  CHANGE_CLIENT,
  CHANGE_TOKEN_STATE,
  GENERAL_GRAPH,
  GENERAL_USER_REDUCER,
  getEditAssumptionsInitialState,
  getUser,
  get_clients,
  logout_user,
  SEND_ALERT,
} from '@plootus/common';
import React, { useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import useEmployerSearch from '../../Reusables/VisualAndAccord/Hooks/useEmployerSearch';
import SideNavbar from '../../Utils/Containers/Sidebar/SideNavbar';
import SearchBox401k from '../../Utils/Search401kNew/SearchBox401kNew';
import UserPicker from '../../Utils/UserPicker/UserPicker';
import Error404 from '../404/Error404';
import AdvisorOrClient from '../Advisor/AdvisorOrClient';
import AssetCatData from '../AssetsScreen/AssetCatData';
import Dashboard from '../Dashboard/Dashboard';
import Employer from '../Employer/Employer';
import IncomeExpTab from '../IncomeExpenseScreen/IncomeExpTab';
import Liabilities from '../LiabilitiesScreen/LiabilitiesScreen';
import ManageAccounts from '../LinkedAccounts/ManageAccounts';
import NetWorth from '../NetWorth/NetWorthData';
import Privacy from '../Privacy/Privacy';
import TermsAndConditionAuth from '../TermsandConditionAuth/TermsandConditionAuth';
import Adash from './Adash';
import styles from './AuthPages.module.css';
import Faqs from './faq';
import { useRef } from 'react';
import FooterAuth from '../../Utils/Containers/FooterAuth/FooterAuth';
import Calculator from '../401kCalculator/Calculator';
import DobModal from '../DOBModal/DobModal';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const theme = createTheme(adaptV4Theme({
  palette: {
    primary: { main: BLUE_PLOOT }, // Purple and green play nicely together.
  },
  typography: { useNextVariants: true },
}));

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

function AuthPages() {
  const token = localStorage.getItem('jwt_token') || getCookie('jwt_token');

  const dispatch = useDispatch();
  const [showDobModal, setShowDobModal] = useState(false);
  const [drop, setDrop] = useState(false);
  const [loading, setloading] = useState(true);

  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [solutionsClicked, setSolutionsClicked] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [resourcesClicked, setResourcesClicked] = useState(false);
  const user = useSelector((state) => state.userReducer);

  const props = useEmployerSearch();

  const myL = useRef('/');

  myL.current = useLocation().pathname;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        solutionsOpen &&
        !event.target.closest(`.${styles.solutionsContainer}`)
      ) {
        setSolutionsClicked(false);
        setSolutionsOpen(false);
      }
      if (
        resourcesOpen &&
        !event.target.closest(`.${styles.resourcesContainer}`)
      ) {
        setResourcesClicked(false);
        setResourcesOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [solutionsOpen, resourcesOpen]);

  const handleSolutionsEnter = () => {
    if (!solutionsClicked) setSolutionsOpen(true);
  };

  const handleSolutionsLeave = () => {
    if (!solutionsClicked) setSolutionsOpen(false);
  };

  const handleSolutionsClick = () => {
    const newClicked = !solutionsClicked;
    setSolutionsClicked(newClicked);
    setSolutionsOpen(newClicked);
  };

  const handleResourcesEnter = () => {
    if (!resourcesClicked) setResourcesOpen(true);
  };

  const handleResourcesLeave = () => {
    if (!resourcesClicked) setResourcesOpen(false);
  };

  const handleResourcesClick = () => {
    const newClicked = !resourcesClicked;
    setResourcesClicked(newClicked);
    setResourcesOpen(newClicked);
  };

  useEffect(() => {
    async function f() {
      setloading(true);
      let userDataTemp;
      if (token) {
        dispatch({ type: CHANGE_TOKEN_STATE, payload: { token } });
        // Get user data and store to reducer
        userDataTemp = await dispatch(getUser());
        if (userDataTemp?.status === 401) {
          // Remove session token

          dispatch({
            type: SEND_ALERT,
            payload: {
              title: 'Expiration',
              textContent: 'Session Expired',
            },
          });
          dispatch({
            type: GENERAL_USER_REDUCER,
            payload: { session_expired: false },
          });

          await localStorage.removeItem('jwt_token');
          document.cookie = "jwt_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

          dispatch(logout_user());

          setExpire(true);
          // Navigate to onboard
          return;
        }
        console.log('user', user);
      }

      if (userDataTemp?.userType === 'advisor') {
        const temp = await dispatch(get_clients());
        if (!temp.length) {
          localStorage.removeItem('jwt_token');
          dispatch(logout_user());

          dispatch({
            type: SEND_ALERT,
            payload: {
              title: 'Alert',
              textContent: 'Please contact your client.',
            },
          });

          setExpire(true);
          return;
        } else {
          const index = parseInt(await localStorage.getItem('selectedClient'))
            ? parseInt(await localStorage.getItem('selectedClient'))
            : 0;
          await dispatch({
            type: CHANGE_CLIENT,
            payload: index,
          });

          await dispatch({
            type: GENERAL_GRAPH,
            payload: await getEditAssumptionsInitialState(token, temp[index]),
          });
          setloading(false);
        }
      } else {
        if (userDataTemp?.dob === null) {
          setShowDobModal(true);
        }

        await dispatch({
          type: GENERAL_GRAPH,
          payload: await getEditAssumptionsInitialState(token, userDataTemp),
        });
        setloading(false);
      }
    }

    f();
  }, [
    user.advisor.selectedClient,
    user.token,
    localStorage.getItem('jwt_token'),
  ]);

  if (loading) {
    return (
      <div
        style={{
          width: '99vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CircularProgress size={50} />
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <DobModal showDobModal={showDobModal} setShowDobModal={setShowDobModal} />
      <div className={styles.sidebar}>
        <SideNavbar />
      </div>
      <div className={styles.searchDiv}>
        <div className={styles.navLinks}>
          <Link to="/" className={styles.navLink}>
            Overview
          </Link>
          <div
            className={styles.solutionsContainer}
            onMouseEnter={handleSolutionsEnter}
            onMouseLeave={handleSolutionsLeave}
          >
            <span
              className={styles.navLink}
              onClick={handleSolutionsClick}
            >
              Solutions <KeyboardArrowDownIcon className={`${styles.dropdownIcon} ${solutionsOpen ? styles.dropdownIconOpen : ''}`} />
            </span>
            <div className={`${styles.solutionsDropdown} ${solutionsOpen ? styles.showDropdown : ''}`}>
              <Link to="/individual-users" className={styles.dropdownItem} onClick={() => { setSolutionsClicked(false); setSolutionsOpen(false); }}>
                Individual Users
              </Link>
              <Link to="/financial-advisors" className={styles.dropdownItem} onClick={() => { setSolutionsClicked(false); setSolutionsOpen(false); }}>
                Financial Advisors
              </Link>
            </div>
          </div>
          <Link to="/partners" className={styles.navLink}>
            Partners
          </Link>
          <Link to="/newsletter" className={styles.navLink}>
            Newsletter
          </Link>
          <Link to="/finance-101" className={styles.navLink}>
            Finance 101
          </Link>
          <Link to="/press" className={styles.navLink}>
            Press
          </Link>
          <div
            className={styles.resourcesContainer}
            onMouseEnter={handleResourcesEnter}
            onMouseLeave={handleResourcesLeave}
          >
            <span
              className={styles.navLink}
              onClick={handleResourcesClick}
            >
              Resources <KeyboardArrowDownIcon className={`${styles.dropdownIcon} ${resourcesOpen ? styles.dropdownIconOpen : ''}`} />
            </span>
            <div className={`${styles.solutionsDropdown} ${resourcesOpen ? styles.showDropdown : ''}`}>
              <Link to="/find-old-401k" className={styles.dropdownItem} onClick={() => { setResourcesClicked(false); setResourcesOpen(false); }}>
                Find Old 401k
              </Link>
              <Link to="/retirement-calculator" className={styles.dropdownItem} onClick={() => { setResourcesClicked(false); setResourcesOpen(false); }}>
                Retirement Calculator
              </Link>
              <Link to="/unclaimed-money" className={styles.dropdownItem} onClick={() => { setResourcesClicked(false); setResourcesOpen(false); }}>
                Unclaimed Money
              </Link>
              <Link to="/where-is-my-refund" className={styles.dropdownItem} onClick={() => { setResourcesClicked(false); setResourcesOpen(false); }}>
                Where Is My Refund?
              </Link>
            </div>
          </div>
          <Link to="/about" className={styles.navLink}>
            About Us
          </Link>
        </div>
      </div>
      <div className={styles.userName} onClick={() => setDrop(true)}>
        {user ? (
          <div className={styles.userNameNav}>
            <div className={styles.avatar}>
              <Avatar
                name={
                  user.userData && user.userData.firstName
                    ? `${user.userData.firstName} ${user.userData.lastName || ''}`.trim()
                    : ' '
                }
                size="40px"
                round="50%"
              />
            </div>
            <div className={styles.userNameText}>
              <UserPicker
                setDrop={setDrop}
                username={
                  user.userData && user.userData.firstName
                    ? `${user.userData.firstName} ${user.userData.lastName || ''}`.trim()
                    : ''
                }
                dispatch={dispatch}
              />
            </div>
          </div>
        ) : null}
      </div>

      <div className={styles.main_content}>
        <Routes>
          {user?.userData?.userType === 'advisor' ? (
            <Route path="adash" element={<Adash />} />
          ) : null}

          <Route path="dashboard" element={<Dashboard />} />
          <Route path="401k" element={<Employer />} />
          <Route path="incomexp" element={<IncomeExpTab />} />
          <Route path="liabilities" element={<Liabilities />} />
          <Route path="assets" element={<AssetCatData />} />
          <Route path="networth" element={<NetWorth />} />

          <Route path="advisors" element={<AdvisorOrClient />} />
          <Route path="faq" element={<Faqs />} />
          <Route path="linkaccounts" element={<ManageAccounts />} />
          <Route path="401kcalculator" element={<Calculator />} />
          <Route
            path="termsandcondition"
            element={<TermsAndConditionAuth />}
          />
          <Route path="privacypolicy" element={<Privacy />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </div>
      <div className={styles.footer}>
        <FooterAuth />
      </div>
    </div>
  );
}

export default AuthPages;
